import { cva, type VariantProps } from "class-variance-authority";
import { type ForwardedRef, forwardRef, type ImgHTMLAttributes } from "react";

import LoadableImage from "common/components/ui/LoadableImage";

import FallbackProfileImage from "assets/images/profile-placeholders/avatar.png";

const profileImageVariants = cva("rounded-full object-cover", {
  variants: {
    size: {
      "3xs": "size-4",
      "2xs": "size-5",
      xs: "size-6",
      sm: "size-8",
      md: "size-10",
      lg: "size-12",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

export type ProfileImageProps = ImgHTMLAttributes<HTMLImageElement> &
  VariantProps<typeof profileImageVariants> & {
    src: string;
  };

function ProfileImage(
  { size, className, ...rest }: ProfileImageProps,
  ref: ForwardedRef<HTMLImageElement>,
) {
  return (
    <LoadableImage
      ref={ref}
      className={profileImageVariants({ size, className })}
      fallbackImage={FallbackProfileImage}
      {...rest}
    />
  );
}

ProfileImage.displayName = "ProfileImage";

export default forwardRef(ProfileImage);
